import { render } from "./FormHelp.vue?vue&type=template&id=2c84289b"
import script from "./FormHelp.vue?vue&type=script&lang=js"
export * from "./FormHelp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__